<script>
  export let viewBox;
</script>

<svg on:click class="icon" viewBox="{viewBox}">
  <path d="M13.1 9.5L46.9 30 13.1 50.5v-41z"></path>
</svg>
